const TrustPilotReviews = [
	{
		id: '1',
		title: 'Easy to use and save money',
		text: 'The site was easy to use, and I found a storage unit near me with an online price that was less than the storage facility itself. The site walked me through everything I needed to do, and it exceeded my expectations. I was able to complete my booking in a short amount of time. ',
		stars: 5,
		customerName: 'Cheryl Slavinsky ',
		key: 'Cheryl Slavinsky ',
	},
	{
		id: '2',
		title: 'How easy it was!',
		text: "How easy it was! It was so easy to rent a unit. Everything was simple and easy. It's hard enough moving so it was less stressful with how easy they made it to rent a storage unit. ",
		stars: 5,
		customerName: 'Bonnie Ulrick',
		key: 'Bonnie Ulrick',
	},
	{
		id: '3',
		title: 'The online reservation and rental were so easy and fast',
		text: 'I received confirmation and access code within minutes for a rental starting the following day. I also received emails and reminders when my unit was ready. ',
		stars: 5,
		customerName: 'Mike McGraw',
		key: 'Mike McGraw',
	},
	{
		id: '4',
		title: 'I just made a reservation by phone',
		text: 'What a wonderful experience it was! Customer service was so patient with me, made sure I was choosing the closest place to my home, and looked for deals. ',
		stars: 5,
		customerName: 'Lynn San',
		key: 'Lynn San',
	},
];

export default TrustPilotReviews;
